import { EmptyWhereClause } from 'v2/core/services/queryBuilder/whereClause';
import { useFeedStore } from '../store/feedStore';

export function useSearchAnalysesWhereClause() {
  const filterWhereClause = useFeedStore(({ query }) => query.whereClause);

  return filterWhereClause ?? EmptyWhereClause;
}
